// Alberta counties
        const counties = [
            { county_id: 1, name: "Calgary Area", latitude: 51.0447, longitude: -114.0719 },
            { county_id: 2, name: "Edmonton Area", latitude: 53.5461, longitude: -113.4938 },
            { county_id: 3, name: "Fort Saskatchewan", latitude: 53.6980, longitude: -113.2026 },
            { county_id: 4, name: "St. Albert", latitude: 53.6304, longitude: -113.6253 },
            { county_id: 5, name: "Kananaskis I.D.", latitude: 50.8661, longitude: -115.0940 },
            { county_id: 6, name: "I.D. No. 25 Willmore Wilderness", latitude: 53.0000, longitude: -117.0000 },
            { county_id: 7, name: "I.D. No. 24 Wood Buffalo", latitude: 57.0000, longitude: -111.0000 },
            { county_id: 8, name: "I.D. No. 13 Elk Island", latitude: 53.5000, longitude: -112.5000 },
            { county_id: 9, name: "I.D. No. 12 Jasper", latitude: 52.8734, longitude: -118.0814 },
            { county_id: 10, name: "I.D. No. 4 Waterton", latitude: 49.0833, longitude: -113.9167 },
            { county_id: 11, name: "I.D. No. 9 Banff", latitude: 51.1784, longitude: -115.5708 },
            { county_id: 12, name: "I.D. No. 349", latitude: 52.0000, longitude: -110.0000 },
            { county_id: 13, name: "Lac La Biche County", latitude: 54.7667, longitude: -111.9667 },
            { county_id: 14, name: "County of Newell", latitude: 50.7833, longitude: -111.2833 },
            { county_id: 15, name: "County of Forty Mile No. 8", latitude: 49.7167, longitude: -110.7000 },
            { county_id: 16, name: "County of Grande Prairie No. 1", latitude: 55.1667, longitude: -118.8000 },
            { county_id: 17, name: "Kneehill County", latitude: 51.5833, longitude: -113.1000 },
            { county_id: 18, name: "Flagstaff County", latitude: 52.0667, longitude: -112.5000 },
            { county_id: 19, name: "Lacombe County", latitude: 52.4667, longitude: -113.7500 },
            { county_id: 20, name: "M.D. of Fairview No. 136", latitude: 56.2500, longitude: -118.5000 },
            { county_id: 21, name: "Lamont County", latitude: 53.6667, longitude: -112.6500 },
            { county_id: 22, name: "Leduc County", latitude: 53.2500, longitude: -113.5500 },
            { county_id: 23, name: "M.D. of Lesser Slave River No. 124", latitude: 55.2833, longitude: -114.8000 },
            { county_id: 24, name: "County of Lethbridge", latitude: 49.7000, longitude: -112.8333 },
            { county_id: 25, name: "County of Minburn No. 27", latitude: 53.7667, longitude: -110.6500 },
            { county_id: 26, name: "M.D. of Acadia No. 34", latitude: 50.2000, longitude: -111.2000 },
            { county_id: 27, name: "Lac Ste. Anne County", latitude: 53.7000, longitude: -114.3000 },
            { county_id: 28, name: "Brazeau County", latitude: 53.1000, longitude: -115.1000 },
            { county_id: 29, name: "Athabasca County", latitude: 54.7167, longitude: -113.2833 },
            { county_id: 30, name: "County of Barrhead No. 11", latitude: 54.1167, longitude: -114.4000 },
            { county_id: 31, name: "Beaver County", latitude: 53.3333, longitude: -110.7333 },
            { county_id: 32, name: "M.D. of Big Lakes", latitude: 55.2500, longitude: -115.0000 },
            { county_id: 33, name: "M.D. of Bighorn No. 8", latitude: 51.5000, longitude: -115.0000 },
            { county_id: 34, name: "M.D. of Foothills No. 31", latitude: 50.8333, longitude: -113.8333 },
            { county_id: 35, name: "M.D. of Bonnyville No. 87", latitude: 54.2667, longitude: -110.7333 },
            { county_id: 36, name: "County of Northern Lights", latitude: 58.5000, longitude: -117.0000 },
            { county_id: 37, name: "Camrose County", latitude: 52.8333, longitude: -112.8000 },
            { county_id: 38, name: "Cardston County", latitude: 49.2000, longitude: -113.3000 },
            { county_id: 39, name: "Clearwater County", latitude: 52.3000, longitude: -115.3000 },
            { county_id: 40, name: "Clear Hills County", latitude: 56.5000, longitude: -119.0000 },
            { county_id: 41, name: "Cypress County", latitude: 50.1000, longitude: -110.7000 },
            { county_id: 42, name: "Northern Sunrise County", latitude: 56.2500, longitude: -117.5000 },
            { county_id: 43, name: "Birch Hills County", latitude: 53.9667, longitude: -113.2000 },
            { county_id: 44, name: "M.D. of Wainwright No. 61", latitude: 52.8333, longitude: -110.8000 },
            { county_id: 45, name: "Mountain View County", latitude: 51.3667, longitude: -114.5000 },
            { county_id: 46, name: "Sturgeon County", latitude: 53.7500, longitude: -113.6000 },
            { county_id: 47, name: "M.D. of Taber", latitude: 49.7833, longitude: -112.1500 },
            { county_id: 48, name: "County of Thorhild No. 7", latitude: 54.2333, longitude: -112.3000 },
            { county_id: 49, name: "County of Two Hills No. 21", latitude: 53.8667, longitude: -111.3000 },
            { county_id: 50, name: "Starland County", latitude: 51.3667, longitude: -112.0000 },
            { county_id: 51, name: "Vulcan County", latitude: 50.4000, longitude: -113.3000 },
            { county_id: 52, name: "County of St. Paul No. 19", latitude: 54.2000, longitude: -110.6500 },
            { county_id: 53, name: "County of Warner No. 5", latitude: 49.5833, longitude: -111.0000 },
            { county_id: 54, name: "Westlock County", latitude: 54.1333, longitude: -113.8000 },
            { county_id: 55, name: "County of Wetaskiwin No. 10", latitude: 52.9667, longitude: -113.4000 },
            { county_id: 56, name: "Wheatland County", latitude: 51.2500, longitude: -113.2000 },
            { county_id: 57, name: "Woodlands County", latitude: 55.5000, longitude: -114.5000 },
            { county_id: 58, name: "County of Vermilion River", latitude: 53.3667, longitude: -110.8667 },
            { county_id: 59, name: "M.D. of Ranchland No. 66", latitude: 50.0000, longitude: -114.0000 },
            { county_id: 60, name: "M.D. of Opportunity No. 17", latitude: 56.0000, longitude: -115.5000 },
            { county_id: 61, name: "County of Paintearth No. 18", latitude: 52.3333, longitude: -112.0000 },
            { county_id: 62, name: "Parkland County", latitude: 53.5000, longitude: -114.1000 },
            { county_id: 63, name: "M.D. of Peace No. 135", latitude: 56.5000, longitude: -117.0000 },
            { county_id: 64, name: "M.D. of Pincher Creek No. 9", latitude: 49.5000, longitude: -113.9500 },
            { county_id: 65, name: "County of Stettler No. 6", latitude: 52.3167, longitude: -112.7333 },
            { county_id: 66, name: "M.D. of Provost No. 52", latitude: 52.3667, longitude: -110.3000 },
            { county_id: 67, name: "Yellowhead County", latitude: 53.6000, longitude: -115.7000 },
            { county_id: 68, name: "Red Deer County", latitude: 52.2667, longitude: -113.8000 },
            { county_id: 69, name: "Rocky View County", latitude: 51.1000, longitude: -114.0000 },
            { county_id: 70, name: "Saddle Hills County", latitude: 55.2500, longitude: -119.0000 },
            { county_id: 71, name: "Smoky Lake County", latitude: 54.0000, longitude: -112.0000 },
            { county_id: 72, name: "M.D. of Smoky River No. 130", latitude: 55.3333, longitude: -116.5000 },
            { county_id: 73, name: "M.D. of Spirit River No. 133", latitude: 55.4500, longitude: -118.2000 },
            { county_id: 74, name: "Ponoka County", latitude: 52.6667, longitude: -113.6500 },
            { county_id: 75, name: "M.D. of Willow Creek No. 26", latitude: 49.8333, longitude: -113.2000 },
            { county_id: 76, name: "M.D. of Greenview No. 16", latitude: 54.5000, longitude: -118.5000 },
            { county_id: 77, name: "Special Areas 3", latitude: 51.0000, longitude: -110.0000 },
            { county_id: 78, name: "Special Areas 4", latitude: 50.5000, longitude: -110.5000 },
            { county_id: 79, name: "Special Areas 2", latitude: 51.5000, longitude: -110.5000 },
            { county_id: 80, name: "Mackenzie County", latitude: 59.0000, longitude: -117.0000 },
            { county_id: 81, name: "Regional Municipality of Wood Buffalo", latitude: 56.7000, longitude: -111.4000 },
            { county_id: 82, name: "Strathcona County", latitude: 53.6000, longitude: -113.2000 },
            { county_id: 83, name: "Municipality of Jasper", latitude: 52.8734, longitude: -118.0814 },
            { county_id: 84, name: "Municipality of Crowsnest Pass", latitude: 49.6000, longitude: -114.5000 },
            { county_id: 85, name: "Drumheller", latitude: 51.4667, longitude: -112.7167 }

        ];

        // Global variables
        let map, currentMarker;
        let countyMarkers = [];
        let temperatureChart, precipitationChart;
        let currentWeatherData = [];
        let ALL_PREDICTIONS = [];
        let HISTORICAL_DATA = [];
        let tempForecastChart, et0ForecastChart, precipForecastChart;
        let historicalTempChart, historicalPrecipChart;
        let currentViewType = null; // Track current view type: 'seasonal', 'monthly', 'historical', or 'current'
        let historicalFilters = { season: 'Winter', year: new Date().getFullYear() };
        let lastPredictionFallbackMessage = '';
        let historicalRangeYears = [];
        let selectedAverageWindowYears = 10;
        const historicalAveragesCache = new Map();
        const historicalAveragesRequests = new Map();
        let mapCurrentWeather = null;

        const PREDICTION_SHARED_HEADERS = [
            'county_id',
            'predict_horizon_months',
            'y_pred_tmax', // primary
            // allow legacy mean temp header in case monthly CSV hasn't been migrated
            'y_pred_tmean',
            'y_pred_et0_fao_evapotranspiration',
            'y_pred_precip',
            'forecast_type'
        ];

        const VIEW_SPECIFIC_PREDICTION_HEADERS = {
            seasonal: ['target_season', 'target_season_start', 'predict_horizon_seasons'],
            monthly: ['target_month', 'target_month_start']
        };

        function getRequiredPredictionHeaders(viewType) {
            const specific = VIEW_SPECIFIC_PREDICTION_HEADERS[viewType] || [];
            return [...PREDICTION_SHARED_HEADERS, ...specific];
        }

        const HISTORICAL_REQUIRED_HEADERS = [
            'county_id',
            'date',
            'temperature_2m_mean',
            'precipitation_sum',
            'et0_fao_evapotranspiration'
        ];

        const SEASON_START_MONTH = {
            Winter: 12,
            Spring: 3,
            Summer: 6,
            Fall: 9
        };

        function pickField(row, primary, ...fallbacks) {
            if (!row) return null;
            for (const key of [primary, ...fallbacks]) {
                if (row[key] !== undefined && row[key] !== null && row[key] !== '') return row[key];
            }
            return null;
        }

        function normalizePredictionRow(row) {
            if (!row || row.__normalized) return row;
            if (row.county_id != null) row.county_id = String(row.county_id).trim();
            if (row.predict_horizon_seasons != null) row.predict_horizon_seasons = String(row.predict_horizon_seasons).trim();
            if (row.predict_horizon_months != null) row.predict_horizon_months = String(row.predict_horizon_months).trim();
            if (row.y_pred_tmax == null) row.y_pred_tmax = pickField(row, 'y_pred_tmax', 'y_pred_tmean', 'y_pred_temp');
            if (row.pred_tmax_class == null) row.pred_tmax_class = pickField(row, 'pred_tmax_class', 'pred_temp_class');
            if (row.tmax_training_mean == null) row.tmax_training_mean = pickField(row, 'tmax_training_mean', 'temp_training_mean');
            if (row.tmax_training_std == null) row.tmax_training_std = pickField(row, 'tmax_training_std', 'temp_training_std');
            if (row.forecast_type != null) row.forecast_type = String(row.forecast_type).trim().toLowerCase();
            row._county_id = getCountyIdNumber(row);
            row._horizon_seasons = getHorizonNumber(row.predict_horizon_seasons);
            row._horizon_months = getHorizonNumber(row.predict_horizon_months);
            row.__normalized = true;
            return row;
        }

        function getForecastType(row) {
            return row?.forecast_type || '';
        }

        function getCountyIdNumber(row) {
            const raw = row?.county_id;
            if (raw == null) return NaN;
            const value = parseFloat(String(raw).trim());
            return Number.isFinite(value) ? value : NaN;
        }

        function getHorizonNumber(value) {
            const num = parseFloat(String(value || '').trim());
            return Number.isFinite(num) ? num : NaN;
        }

        function getAveragePeriodForView(viewType) {
            if (viewType === 'monthly') return 'monthly';
            if (viewType === 'seasonal') return 'seasonal';
            return null;
        }

        function getAverageDatasetKey(viewType, windowYears = selectedAverageWindowYears) {
            const period = getAveragePeriodForView(viewType);
            if (!period) return null;
            return `${period}|${windowYears}`;
        }

        function getAverageWindowLabel(windowYears = selectedAverageWindowYears) {
            return `${windowYears}-year average`;
        }

        function monthNameToNumber(monthName) {
            if (!monthName) return NaN;
            const date = new Date(`${monthName} 1, 2000`);
            if (Number.isNaN(date.getTime())) return NaN;
            return date.getMonth() + 1;
        }

        function updateAverageColumnHeaders() {
            const label = getAverageWindowLabel();
            const tempHeader = document.getElementById('tempAvgHeader');
            const et0Header = document.getElementById('et0AvgHeader');
            const precipHeader = document.getElementById('precipAvgHeader');
            if (tempHeader) tempHeader.textContent = `Temp vs ${label}`;
            if (et0Header) et0Header.textContent = `ET₀ vs ${label}`;
            if (precipHeader) precipHeader.textContent = `Precip vs ${label}`;
        }

        async function loadHistoricalAverageDataset(viewType, windowYears = selectedAverageWindowYears) {
            const period = getAveragePeriodForView(viewType);
            if (!period) return;
            const cacheKey = `${period}|${windowYears}`;
            if (historicalAveragesCache.has(cacheKey)) return;
            if (historicalAveragesRequests.has(cacheKey)) {
                await historicalAveragesRequests.get(cacheKey);
                return;
            }

            const request = (async () => {
                const params = new URLSearchParams({
                    period: period,
                    window_years: String(windowYears),
                    _t: Date.now()
                });
                const response = await fetch(`/api/weather/historical-averages?${params.toString()}`);
                if (!response.ok) {
                    throw new Error(`Failed to load ${period} historical averages (${windowYears}y)`);
                }
                const csvText = await response.text();
                const parsed = await new Promise((resolve, reject) => {
                    Papa.parse(csvText, {
                        header: true,
                        dynamicTyping: true,
                        skipEmptyLines: true,
                        complete: resolve,
                        error: reject
                    });
                });

                const index = new Map();
                (parsed.data || []).forEach(row => {
                    const countyId = Number(row.county_id);
                    if (!Number.isFinite(countyId)) return;
                    if (period === 'monthly') {
                        const month = Number(row.month);
                        if (!Number.isFinite(month)) return;
                        index.set(`${countyId}|${month}`, row);
                    } else if (period === 'seasonal') {
                        const season = String(row.season || '').trim();
                        if (!season) return;
                        index.set(`${countyId}|${season}`, row);
                    }
                });
                historicalAveragesCache.set(cacheKey, index);
            })();

            historicalAveragesRequests.set(cacheKey, request);
            try {
                await request;
            } finally {
                historicalAveragesRequests.delete(cacheKey);
            }
        }

        function getHistoricalAverageRowForPrediction(row, viewType = currentViewType, windowYears = selectedAverageWindowYears) {
            if (!row) return null;
            const cacheKey = getAverageDatasetKey(viewType, windowYears);
            if (!cacheKey) return null;
            const index = historicalAveragesCache.get(cacheKey);
            if (!index) return null;
            const countyId = Number(row.county_id);
            if (!Number.isFinite(countyId)) return null;

            if (viewType === 'monthly') {
                let monthNum = NaN;
                const monthDate = parseDateOrNull(row.target_month_start);
                if (monthDate) {
                    monthNum = monthDate.getMonth() + 1;
                } else {
                    monthNum = monthNameToNumber(row.target_month);
                }
                if (!Number.isFinite(monthNum)) return null;
                return index.get(`${countyId}|${monthNum}`) || null;
            }

            if (viewType === 'seasonal') {
                const season = String(row.target_season || '').trim();
                if (!season) return null;
                return index.get(`${countyId}|${season}`) || null;
            }

            return null;
        }

        function inferTargetPeriodDays(row, viewType, avgRow = null) {
            if (viewType === 'monthly') {
                const targetDate = parseDateOrNull(row?.target_month_start);
                if (targetDate) {
                    return new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, 0).getDate();
                }
            } else if (viewType === 'seasonal') {
                const targetDate = parseDateOrNull(row?.target_season_start);
                if (targetDate) {
                    const seasonEnd = new Date(targetDate);
                    seasonEnd.setMonth(seasonEnd.getMonth() + 3);
                    const days = Math.round((seasonEnd - targetDate) / (24 * 60 * 60 * 1000));
                    if (Number.isFinite(days) && days > 0) return days;
                }
            }

            // Fallback: derive typical days per period from historical aggregate rows.
            const records = Number(avgRow?.records);
            const windowYears = Number(avgRow?.window_years);
            if (Number.isFinite(records) && Number.isFinite(windowYears) && windowYears > 0) {
                return records / windowYears;
            }
            return NaN;
        }

        function getAverageValueForRow(row, metric, viewType = currentViewType) {
            const avgRow = getHistoricalAverageRowForPrediction(row, viewType, selectedAverageWindowYears);
            if (!avgRow) return NaN;

            if (metric === 'temp') {
                const target = String(row?.temperature_model_target || '').toLowerCase();
                const forecastIsMeanTemp = target === 'tas_county_season' || target === 'tas_county_month';
                const field = forecastIsMeanTemp ? 'temperature_2m_mean_avg' : 'temperature_2m_max_avg';
                const value = Number(avgRow[field]);
                return Number.isFinite(value) ? value : NaN;
            }
            if (metric === 'et0') {
                const totalFieldValue = Number(avgRow.et0_fao_evapotranspiration_total_avg);
                if (Number.isFinite(totalFieldValue)) return totalFieldValue;

                const dailyAvg = Number(avgRow.et0_fao_evapotranspiration_avg);
                if (Number.isFinite(dailyAvg)) {
                    const periodDays = inferTargetPeriodDays(row, viewType, avgRow);
                    if (Number.isFinite(periodDays) && periodDays > 0) return dailyAvg * periodDays;
                    return dailyAvg;
                }
                return NaN;
            }
            if (metric === 'precip') {
                const totalFieldValue = Number(avgRow.precipitation_sum_total_avg);
                if (Number.isFinite(totalFieldValue)) return totalFieldValue;

                const dailyAvg = Number(avgRow.precipitation_sum_avg);
                if (Number.isFinite(dailyAvg)) {
                    const periodDays = inferTargetPeriodDays(row, viewType, avgRow);
                    if (Number.isFinite(periodDays) && periodDays > 0) return dailyAvg * periodDays;
                    return dailyAvg;
                }
                return NaN;
            }
            return NaN;
        }

        function isFutureRow(row) {
            const forecastType = getForecastType(row);
            if (forecastType) return forecastType === 'future';
            const fallbackClasses = [
                row?.true_tmax_class,
                row?.true_et0_fao_evapotranspiration_class,
                row?.true_precip_class,
                row?.true_temp_class,
                row?.true_et0_class
            ];
            return fallbackClasses.some(value => String(value || '').trim().toLowerCase() === 'future');
        }


        function findMissingFields(headers, requiredFields) {
            if (!Array.isArray(headers)) return requiredFields;
            const normalized = headers.map(h => (typeof h === 'string' ? h.trim() : h));
            return requiredFields.filter(field => !normalized.includes(field));
        }

        function formatDateString(date) {
            if (!date) return '';
            const d = new Date(date);
            if (Number.isNaN(d.getTime())) return '';
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        }

        function getSeasonForMonth(month) {
            if (month === 12 || month <= 2) return 'Winter';
            if (month >= 3 && month <= 5) return 'Spring';
            if (month >= 6 && month <= 8) return 'Summer';
            return 'Fall';
        }

        function getSeasonDateRange(season, year) {
            const startMonth = SEASON_START_MONTH[season] || 1;
            let startYear = Number(year);
            if (!Number.isFinite(startYear)) startYear = new Date().getFullYear();
            const startDate = new Date(startYear, startMonth - 1, 1);
            const endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + 3);
            endDate.setDate(0);
            return { start: startDate, end: endDate };
        }

        function formatTemperature(value) {
            if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
            return Math.round(Number(value));
        }

        function formatClassLabel(value) {
            if (value === null || value === undefined) return 'Average';
            const text = String(value).trim();
            const lower = text.toLowerCase();
            if (lower === 'above') return 'Above Average';
            if (lower === 'below') return 'Below Average';
            return text;
        }

        function formatPredictionDelta(value, average, decimals, unitLabel, averageWindowYears = selectedAverageWindowYears) {
            const numericValue = Number(value);
            const numericAvg = Number(average);
            const avgLabel = `${averageWindowYears} year average`;
            if (!Number.isFinite(numericValue) || !Number.isFinite(numericAvg)) {
                return { text: `${avgLabel} unavailable`, className: 'pred-average' };
            }
            const diff = numericValue - numericAvg;
            const absDiff = Math.abs(diff);
            const formatted = absDiff.toFixed(decimals);
            if (absDiff < Math.pow(10, -decimals)) {
                return { text: `At ${avgLabel}`, className: 'pred-average' };
            }
            const direction = diff > 0 ? 'above' : 'below';
            const unit = unitLabel ? ` ${unitLabel}` : '';
            return {
                text: `${formatted}${unit} ${direction} ${avgLabel}`,
                className: diff > 0 ? 'pred-above' : 'pred-below'
            };
        }

        function formatHorizonLabel(viewType, horizonValue, targetLabel = '') {
            if (!Number.isFinite(horizonValue)) return '—';
            const unit = viewType === 'seasonal' ? 'season' : 'month';
            const base = `for the next ${horizonValue} ${unit}${horizonValue === 1 ? '' : 's'}`;
            if (targetLabel) return `${base} (${targetLabel})`;
            return base;
        }

        function formatTimeLabel(date) {
            if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const suffix = hours >= 12 ? 'pm' : 'am';
            const normalizedHour = ((hours + 11) % 12) + 1;
            const paddedMinutes = String(minutes).padStart(2, '0');
            if (paddedMinutes === '00') return `${normalizedHour} ${suffix}`;
            return `${normalizedHour}:${paddedMinutes} ${suffix}`;
        }

        function formatWindDirection(degrees) {
            if (!Number.isFinite(degrees)) return '';
            const dirs = ['N','NNE','NE','ENE','E','ESE','SE','SSE','S','SSW','SW','WSW','W','WNW','NW','NNW'];
            const index = Math.round(degrees / 22.5) % 16;
            return dirs[index] || '';
        }

        function updateTargetPredictionLabel() {
            const labelEl = document.getElementById('targetPredictionLabel');
            const groupEl = document.getElementById('targetRangeGroup');
            const rangeLabelEl = document.getElementById('targetRangeLabel');
            const monthlyTargetEl = document.getElementById('monthlyTargetMonth');
            const monthlyNoteEl = document.getElementById('monthlyTargetNote');
            if (!labelEl) return;

            if (currentViewType === 'seasonal') {
                if (groupEl) groupEl.style.display = 'block';
                if (rangeLabelEl) rangeLabelEl.textContent = 'Target Season:';
            } else if (currentViewType === 'monthly') {
                if (groupEl) groupEl.style.display = 'none';
                if (rangeLabelEl) rangeLabelEl.textContent = 'Target Month:';
            } else {
                if (groupEl) groupEl.style.display = 'none';
                labelEl.textContent = 'Select Seasonal or Monthly view to show the target period';
                lastPredictionFallbackMessage = '';
                updateTargetPredictionNote();
                return;
            }

            if (currentViewType === 'seasonal') {
                const season = document.getElementById('seasonalSeason')?.value;
                const year = document.getElementById('seasonalYear')?.value;
                if (season && year) {
                    labelEl.textContent = `${season} ${year}`;
                } else {
                    labelEl.textContent = 'Select a target season and year';
                }
            } else if (currentViewType === 'monthly') {
                if (groupEl) groupEl.style.display = 'none';
                updateMonthlyTargetMonth();
                if (monthlyNoteEl) {
                    monthlyNoteEl.textContent = '';
                    monthlyNoteEl.style.display = 'none';
                }
            }
            updateTargetPredictionNote();
            if (monthlyTargetEl && currentViewType !== 'monthly') {
                monthlyTargetEl.textContent = 'Select a monthly horizon';
            }
            if (monthlyNoteEl && currentViewType !== 'monthly') {
                monthlyNoteEl.textContent = '';
                monthlyNoteEl.style.display = 'none';
            }
        }

        function updateMonthlyTargetMonth() {
            const monthlyTargetEl = document.getElementById('monthlyTargetMonth');
            if (!monthlyTargetEl) return;
            const countyId = parseInt(document.getElementById('countySelect')?.value);
            const horizon = parseInt(document.getElementById('monthlyHorizon')?.value);
            if (Number.isFinite(horizon)) {
                const selectedRow = Number.isFinite(countyId)
                    ? getLatestMonthlyForecastRow(countyId, horizon)
                    : null;
                const targetDate = parseDateOrNull(selectedRow?.target_month_start);
                if (targetDate) {
                    monthlyTargetEl.textContent = targetDate.toLocaleString('en-US', { month: 'long', year: 'numeric' });
                } else {
                    monthlyTargetEl.textContent = Number.isFinite(countyId)
                        ? 'Loading target month from predictions...'
                        : 'Select a county to load target month';
                }
            } else {
                monthlyTargetEl.textContent = 'Select a monthly horizon';
            }
        }

        function updateTargetPredictionNote() {
            const noteEl = document.getElementById('targetPredictionNote');
            const monthlyNoteEl = document.getElementById('monthlyTargetNote');
            if (currentViewType === 'monthly') {
                if (!monthlyNoteEl) return;
                if (lastPredictionFallbackMessage && lastPredictionFallbackMessage.toLowerCase().includes('unavailable')) {
                    monthlyNoteEl.textContent = lastPredictionFallbackMessage;
                    monthlyNoteEl.style.display = 'block';
                } else {
                    monthlyNoteEl.textContent = '';
                    monthlyNoteEl.style.display = 'none';
                }
                return;
            }
            if (!noteEl) return;
            if (lastPredictionFallbackMessage) {
                noteEl.textContent = lastPredictionFallbackMessage;
                noteEl.style.display = 'block';
            } else {
                noteEl.textContent = '';
                noteEl.style.display = 'none';
            }
        }

        function handlePredictionCsvResults(results, viewType) {
            const requiredHeaders = getRequiredPredictionHeaders(viewType);
            let missingHeaders = findMissingFields(results.meta.fields, requiredHeaders);
            const tempFields = ['y_pred_tmax', 'y_pred_tmean', 'y_pred_temp'];
            const hasTempField = tempFields.some(f => results.meta.fields?.includes(f));
            if (hasTempField) {
                missingHeaders = missingHeaders.filter(h => !tempFields.includes(h));
            }
            if (viewType === 'monthly' && missingHeaders.includes('forecast_type')) {
                missingHeaders = missingHeaders.filter(h => h !== 'forecast_type');
            }
            if (missingHeaders.length) {
                reportWeatherDebug(`Predictions CSV missing columns (${viewType}): ${missingHeaders.join(', ')}`);
                showError('Forecast data is temporarily unavailable.');
                return false;
            }

            clearError();
            ALL_PREDICTIONS = results.data.filter(r => r.county_id).map(normalizePredictionRow);
            populateHistoricalYears();
            populateSeasonalYears();

            if (viewType === 'seasonal' || viewType === 'monthly') {
                renderPredictionsTable();
                updateLongTermCharts();
                updateMonthlyTargetMonth();
            }

            console.log('Loaded', viewType, 'predictions:', ALL_PREDICTIONS.length, 'rows');
            return true;
        }

        function parseDateOrNull(value) {
            if (!value) return null;
            const text = String(value).trim();
            const dateOnly = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (dateOnly) {
                const year = Number(dateOnly[1]);
                const month = Number(dateOnly[2]);
                const day = Number(dateOnly[3]);
                const parsedLocal = new Date(year, month - 1, day);
                return Number.isNaN(parsedLocal.getTime()) ? null : parsedLocal;
            }
            const parsed = new Date(text);
            if (Number.isNaN(parsed.getTime())) return null;
            return parsed;
        }

        function getTargetLabelForRow(row) {
            if (!row) return '—';
            const seasonStart = parseDateOrNull(row.target_season_start);
            const monthStart = parseDateOrNull(row.target_month_start);
            const year = (seasonStart || monthStart)?.getFullYear();

            if (row.target_season) {
                return year ? `${row.target_season} ${year}` : row.target_season;
            }
            if (row.target_month) {
                return year ? `${row.target_month} ${year}` : row.target_month;
            }

            const fallbackDate = seasonStart || monthStart;
            if (fallbackDate) {
                return fallbackDate.toLocaleString('en-US', { month: 'long', year: 'numeric' });
            }
            return '—';
        }

        function findClosestByDate(rows, targetDateStr) {
            const targetDate = parseDateOrNull(targetDateStr);
            if (!targetDate) return null;
            let closest = null;
            let minDiff = Number.POSITIVE_INFINITY;
            rows.forEach(row => {
                const candidate = getPredictionTargetDate(row);
                if (!candidate) return;
                const diff = Math.abs(candidate - targetDate);
                if (diff < minDiff) {
                    minDiff = diff;
                    closest = row;
                }
            });
            return closest;
        }
        function setPredictionsPlaceholder(message = 'Select a forecast view and county to load predictions.') {
            const tbody = document.getElementById('predictionsTableBody');
            if (!tbody) return;
            tbody.innerHTML = `<tr><td colspan=\"8\" style=\"text-align:center;color:#999;\">${message}</td></tr>`;
        }

        // Load data based on view type
        async function loadDataForViewType(viewType) {
            if (viewType === 'historical') {
                await loadHistoricalSlice();
                return;
            }

            let endpoint;
            if (viewType === 'seasonal') {
                endpoint = '/api/weather/seasonal';
            } else if (viewType === 'monthly') {
                endpoint = '/api/weather/monthly';
            } else {
                console.error('Unknown view type:', viewType);
                return;
            }

            try {
                const response = await fetch(endpoint);
                if (!response.ok) {
                    let details = '';
                    try {
                        const payload = await response.json();
                        if (Array.isArray(payload?.missing_headers) && payload.missing_headers.length) {
                            details = ` Missing columns: ${payload.missing_headers.join(', ')}`;
                        } else if (payload?.error) {
                            details = ` ${payload.error}`;
                        }
                    } catch (_err) {
                        // Non-JSON error response; keep generic message.
                    }
                    reportWeatherDebug(`Failed to load ${viewType} data (HTTP ${response.status}).${details}`);
                    showError('Forecast data is temporarily unavailable.');
                    return;
                }
                const csvText = await response.text();

                Papa.parse(csvText, {
                    header: true,
                    dynamicTyping: true,
                    skipEmptyLines: true,
                    complete: function(results) {
                        if (!handlePredictionCsvResults(results, viewType)) {
                            showError('Forecast data is temporarily unavailable.');
                        }
                    },
                    error: function(error) {
                        console.error('CSV parsing error:', error);
                        reportWeatherDebug(`CSV parse error (${viewType}): ${error?.message || error}`);
                        showError('Forecast data is temporarily unavailable.');
                    }
                });
            } catch (error) {
                console.error(`Error loading ${viewType} data:`, error);
                reportWeatherDebug(`Data load error (${viewType}): ${error?.message || error}`);
                showError('Forecast data is temporarily unavailable.');
            }
        }

        function showHistoricalError(message) {
            const container = document.getElementById('historicalError');
            if (container) {
                container.innerHTML = `<div class="error">${message}</div>`;
            }
        }

        function clearHistoricalError() {
            const container = document.getElementById('historicalError');
            if (container) container.innerHTML = '';
        }

        function destroyHistoricalCharts() {
            if (historicalTempChart) {
                historicalTempChart.destroy();
                historicalTempChart = null;
            }
            if (historicalPrecipChart) {
                historicalPrecipChart.destroy();
                historicalPrecipChart = null;
            }
        }

        async function loadHistoricalSlice() {
            const countyId = parseInt(document.getElementById('countySelect').value);
            if (!countyId) {
                showHistoricalError('Select a county to load historical data.');
                HISTORICAL_DATA = [];
                updateHistoricalDisplay();
                return;
            }

            const season = document.getElementById('historicalSeason').value;
            const range = document.getElementById('historicalRange').value;
            let startYear;
            let endYear;
            if (range === 'custom') {
                startYear = parseInt(document.getElementById('historicalStartYear').value);
                endYear = parseInt(document.getElementById('historicalEndYear').value);
            } else {
                endYear = parseInt(document.getElementById('historicalYear').value) || new Date().getFullYear();
                startYear = endYear - parseInt(range) + 1;
            }

            if (!Number.isFinite(startYear) || !Number.isFinite(endYear)) {
                showHistoricalError('Select a valid year range.');
                HISTORICAL_DATA = [];
                updateHistoricalDisplay();
                return;
            }

            if (startYear > endYear) {
                [startYear, endYear] = [endYear, startYear];
            }

            historicalFilters = { season, year: endYear, range: `${startYear}-${endYear}` };

            let start = getSeasonDateRange(season, startYear).start;
            let end = getSeasonDateRange(season, endYear).end;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            end = new Date(end.getFullYear(), end.getMonth(), end.getDate());
            if (end > today) end = today;
            if (start > end) start = new Date(end);
            const startDateStr = formatDateString(start);
            const endDateStr = formatDateString(end) || startDateStr;
            const params = new URLSearchParams({
                county_id: countyId,
                start_date: startDateStr,
                end_date: endDateStr
            });

            try {
                const response = await fetch(`/api/weather/historical?${params.toString()}`);
                if (!response.ok) throw new Error('Failed to load historical data');
                const csvText = await response.text();
                Papa.parse(csvText, {
                    header: true,
                    dynamicTyping: true,
                    skipEmptyLines: true,
                    complete: function(results) {
                        const missing = findMissingFields(results.meta.fields, HISTORICAL_REQUIRED_HEADERS);
                        if (missing.length) {
                            reportWeatherDebug(`Historical CSV missing columns: ${missing.join(', ')}`);
                            showHistoricalError('Historical data is temporarily unavailable.');
                            HISTORICAL_DATA = [];
                            updateHistoricalDisplay();
                            return;
                        }
                        HISTORICAL_DATA = results.data;
                        populateHistoricalYears();
                        populateHistoricalRangeYears();
                        updateHistoricalDisplay();
                        populateSeasonalYears();
                    },
                    error: function(error) {
                        console.error('Historical CSV parsing error:', error);
                        reportWeatherDebug(`Historical CSV parse error: ${error?.message || error}`);
                        showHistoricalError('Historical data is temporarily unavailable.');
                        HISTORICAL_DATA = [];
                        updateHistoricalDisplay();
                    }
                });
            } catch (error) {
                console.error('Error fetching historical data:', error);
                reportWeatherDebug(`Historical data fetch error: ${error?.message || error}`);
                showHistoricalError('Historical data is temporarily unavailable.');
                HISTORICAL_DATA = [];
                updateHistoricalDisplay();
            }
        }

        function isDateInSeason(date, season) {
            if (!date || !season) return false;
            const month = date.getMonth() + 1;
            if (season === 'Winter') return month === 12 || month <= 2;
            if (season === 'Spring') return month >= 3 && month <= 5;
            if (season === 'Summer') return month >= 6 && month <= 8;
            if (season === 'Fall') return month >= 9 && month <= 11;
            return false;
        }

        function getSeasonYear(date, season) {
            if (!date) return null;
            const year = date.getFullYear();
            if (season === 'Winter') {
                const month = date.getMonth() + 1;
                return month <= 2 ? year - 1 : year;
            }
            return year;
        }

        function updateHistoricalDisplay() {
            const tbody = document.getElementById('historicalTableBody');
            if (!tbody) return;
            clearHistoricalError();

            if (!HISTORICAL_DATA.length) {
                tbody.innerHTML = '<tr><td colspan="4" class="loading">No historical data available for the selected period.</td></tr>';
                destroyHistoricalCharts();
                return;
            }

            const season = document.getElementById('historicalSeason')?.value;
            const seasonRows = HISTORICAL_DATA.filter(row => {
                const date = parseDateOrNull(row.date);
                return date && isDateInSeason(date, season);
            });
            if (!seasonRows.length) {
                tbody.innerHTML = '<tr><td colspan="4" class="loading">No seasonal data available for the selected range.</td></tr>';
                destroyHistoricalCharts();
                return;
            }

            const aggregated = aggregateHistoricalSeasonal(seasonRows, season);
            const sorted = aggregated.sort((a, b) => a.year - b.year);
            const subtitleText = sorted.length
                ? `${season} ${sorted[0].year}–${sorted[sorted.length - 1].year} averages`
                : `${season} averages`;
            const tempSubtitle = document.getElementById('historicalTempSubtitle');
            const precipSubtitle = document.getElementById('historicalPrecipSubtitle');
            if (tempSubtitle) tempSubtitle.textContent = subtitleText;
            if (precipSubtitle) precipSubtitle.textContent = subtitleText;
            tbody.innerHTML = '';
            sorted.forEach(row => {
                const tempGain = row.temperature_2m_mean != null ? Number(row.temperature_2m_mean).toFixed(2) : '—';
                const precipGain = row.precipitation_sum != null ? Number(row.precipitation_sum).toFixed(2) : '—';
                const et0Gain = row.et0_fao_evapotranspiration != null ? Number(row.et0_fao_evapotranspiration).toFixed(2) : '—';

                const tr = document.createElement('tr');
                tr.innerHTML = `
                    <td>${row.year}</td>
                    <td>${tempGain}</td>
                    <td>${precipGain}</td>
                    <td>${et0Gain}</td>
                `;
                tbody.appendChild(tr);
            });

            updateHistoricalCharts(sorted);
        }

        function updateHistoricalCharts(rows) {
            if (!rows.length) {
                destroyHistoricalCharts();
                return;
            }

            const labels = rows.map(r => String(r.year));
            const temperatures = rows.map(r => r.temperature_2m_mean != null ? Number(r.temperature_2m_mean) : null);
            const precipitation = rows.map(r => r.precipitation_sum != null ? Number(r.precipitation_sum) : null);

            const tempCtx = document.getElementById('historicalTempChart').getContext('2d');
            if (historicalTempChart) historicalTempChart.destroy();
            historicalTempChart = new Chart(tempCtx, {
                type: 'line',
                data: {
                    labels,
                    datasets: [{
                        label: 'Avg Mean Temperature (°C)',
                        data: temperatures,
                        borderColor: '#e67e22',
                        borderWidth: 3,
                        pointRadius: 2,
                        fill: false,
                        tension: 0.25
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: false } }
                }
            });

            const precipCtx = document.getElementById('historicalPrecipChart').getContext('2d');
            if (historicalPrecipChart) historicalPrecipChart.destroy();
            historicalPrecipChart = new Chart(precipCtx, {
                type: 'line',
                data: {
                    labels,
                    datasets: [{
                        label: 'Total Precipitation (mm)',
                        data: precipitation,
                        borderColor: '#3498db',
                        borderWidth: 3,
                        pointRadius: 2,
                        fill: false,
                        tension: 0.25
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: true } }
                }
            });
        }

        function aggregateHistoricalSeasonal(rows, season) {
            const buckets = new Map();
            rows.forEach(row => {
                const date = parseDateOrNull(row.date);
                if (!date) return;
                const year = getSeasonYear(date, season);
                if (!Number.isFinite(year)) return;
                if (!buckets.has(year)) {
                    buckets.set(year, { year, temp: [], precip: [], et0: [] });
                }
                const bucket = buckets.get(year);
                if (row.temperature_2m_mean != null) bucket.temp.push(Number(row.temperature_2m_mean));
                if (row.precipitation_sum != null) bucket.precip.push(Number(row.precipitation_sum));
                if (row.et0_fao_evapotranspiration != null) bucket.et0.push(Number(row.et0_fao_evapotranspiration));
            });

            const average = arr => arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : null;
            const sum = arr => arr.length ? arr.reduce((a, b) => a + b, 0) : null;

            return Array.from(buckets.values()).map(bucket => ({
                year: bucket.year,
                temperature_2m_mean: average(bucket.temp),
                precipitation_sum: sum(bucket.precip),
                et0_fao_evapotranspiration: sum(bucket.et0)
            }));
        }

        function exportHistoricalData() {
            if (!HISTORICAL_DATA.length) {
                showHistoricalError('No historical data to export.');
                return;
            }

            const headers = ['Year', 'Avg Max Temperature (°C)', 'Total Precipitation (mm)', 'Total ET₀ (mm)'];
            const season = document.getElementById('historicalSeason')?.value;
            const seasonRows = HISTORICAL_DATA.filter(row => {
                const date = parseDateOrNull(row.date);
                return date && isDateInSeason(date, season);
            });
            const aggregated = aggregateHistoricalSeasonal(seasonRows, season).sort((a, b) => a.year - b.year);
            const csvRows = aggregated.map(row => [
                row.year,
                row.temperature_2m_mean != null ? row.temperature_2m_mean : '',
                row.precipitation_sum != null ? row.precipitation_sum : '',
                row.et0_fao_evapotranspiration != null ? row.et0_fao_evapotranspiration : ''
            ].join(','));
            const csvContent = `data:text/csv;charset=utf-8,${[headers.join(','), ...csvRows].join('\n')}`;
            const link = document.createElement('a');
            link.setAttribute('href', encodeURI(csvContent));
            const seasonLabel = historicalFilters.season || 'historical';
            const yearLabel = historicalFilters.year || new Date().getFullYear();
            link.setAttribute('download', `historical_${seasonLabel}_${yearLabel}_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        function exportPredictionsData() {
            const rows = getFilteredPredictionsForView();
            if (!rows.length) {
                showError('No predictions to export');
                return;
            }

            const headers = ['County', 'Horizon', 'Target Season', 'Target Date', 'Temp (°C)', 'Temp Class', 'ET₀ (mm)', 'ET₀ Class', 'Precip (mm)', 'Precip Class'];
            const horizonType = currentViewType === 'seasonal' ? 'predict_horizon_seasons' : 'predict_horizon_months';
            const csvBody = rows.map(row => {
                return [
                    row.county_id,
                    row[horizonType],
                    row.target_season || '',
                    row.target_season_start || '',
                    row.y_pred_tmax != null ? row.y_pred_tmax : '',
                    row.pred_tmax_class || '',
                    row.y_pred_et0_fao_evapotranspiration != null ? row.y_pred_et0_fao_evapotranspiration : '',
                    row.pred_et0_fao_evapotranspiration_class || '',
                    row.y_pred_precip != null ? row.y_pred_precip : '',
                    row.pred_precip_class || ''
                ].join(',');
            });

            const csvContent = [headers.join(','), ...csvBody].join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.setAttribute('href', url);
            const viewLabel = currentViewType || 'predictions';
            link.setAttribute('download', `predictions_${viewLabel}_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }

        // Populate historical year dropdown with years from validation data
        function getAvailableHistoricalYearsForCounty(countyId) {
            const rows = (HISTORICAL_DATA || []).filter(row => Number(row.county_id) === Number(countyId));
            const years = Array.from(new Set(
                rows
                    .map(row => parseDateOrNull(row.date))
                    .filter(date => date)
                    .map(date => date.getFullYear())
            )).sort((a, b) => b - a);

            if (years.length) return years;

            const fallbackYear = new Date().getFullYear();
            return [fallbackYear];
        }

        function populateHistoricalYears() {
            const yearSelect = document.getElementById('historicalYear');
            if (!yearSelect) return;

            const countyId = parseInt(document.getElementById('countySelect')?.value);
            const years = getAvailableHistoricalYearsForCounty(countyId);
            const previousValue = parseInt(yearSelect.value);

            yearSelect.innerHTML = '';
            years.forEach(year => {
                const option = document.createElement('option');
                option.value = year;
                option.textContent = year;
                yearSelect.appendChild(option);
            });

            if (years.includes(previousValue)) {
                yearSelect.value = String(previousValue);
            } else {
                yearSelect.value = String(years[0]);
            }

            const currentSeason = getSeasonForMonth(new Date().getMonth() + 1);
            if (document.getElementById('historicalSeason')) {
                document.getElementById('historicalSeason').value = currentSeason;
                historicalFilters.season = currentSeason;
            }
            historicalFilters.year = parseInt(yearSelect.value) || years[0] || new Date().getFullYear();
        }

        function populateHistoricalRangeYears() {
            const startSelect = document.getElementById('historicalStartYear');
            const endSelect = document.getElementById('historicalEndYear');
            if (!startSelect || !endSelect) return;

            const countyId = parseInt(document.getElementById('countySelect')?.value);
            const years = getAvailableHistoricalYearsForCounty(countyId);
            historicalRangeYears = years;

            const previousStart = parseInt(startSelect.value);
            const previousEnd = parseInt(endSelect.value);

            startSelect.innerHTML = '';
            endSelect.innerHTML = '';
            years.forEach(year => {
                const optStart = document.createElement('option');
                optStart.value = year;
                optStart.textContent = year;
                startSelect.appendChild(optStart);
                const optEnd = document.createElement('option');
                optEnd.value = year;
                optEnd.textContent = year;
                endSelect.appendChild(optEnd);
            });

            const latestYear = years[0];
            const defaultStartYear = years.find(year => year <= latestYear - 9) || years[years.length - 1];

            startSelect.value = years.includes(previousStart) ? String(previousStart) : String(defaultStartYear);
            endSelect.value = years.includes(previousEnd) ? String(previousEnd) : String(latestYear);
        }

        function syncHistoricalRangeUI() {
            const rangeSelect = document.getElementById('historicalRange');
            const yearGroup = document.getElementById('historicalYear')?.closest('.control-group');
            const yearLabel = document.getElementById('historicalYearLabel');
            const customStart = document.getElementById('historicalCustomRange');
            const customEnd = document.getElementById('historicalCustomEndRange');
            if (!rangeSelect || !yearGroup || !customStart || !customEnd) return;

            if (rangeSelect.value === 'custom') {
                yearGroup.style.display = 'none';
                customStart.style.display = 'block';
                customEnd.style.display = 'block';
            } else {
                yearGroup.style.display = 'block';
                customStart.style.display = 'none';
                customEnd.style.display = 'none';
                if (yearLabel) yearLabel.textContent = 'End Year:';
            }
        }

        function populateSeasonalYears() {
            const yearSelect = document.getElementById('seasonalYear');
            if (!yearSelect) return;

            let referenceDate = null;
            if (HISTORICAL_DATA.length) {
                const dates = HISTORICAL_DATA
                    .map(row => parseDateOrNull(row.date))
                    .filter(d => d);
                if (dates.length) {
                    referenceDate = new Date(Math.max(...dates.map(d => d.getTime())));
                }
            }
            if (!referenceDate) referenceDate = new Date();
            const baseYear = referenceDate.getFullYear();
            const years = [baseYear, baseYear + 1];

            const selectedValue = yearSelect.value;
            yearSelect.innerHTML = '';
            years.forEach(year => {
                const option = document.createElement('option');
                option.value = year;
                option.textContent = year;
                yearSelect.appendChild(option);
            });

            if (selectedValue && years.includes(Number(selectedValue))) {
                yearSelect.value = selectedValue;
            }
        }

        // Monthly target alignment must use prediction rows (model anchor), not weather fetch time.
        function getLatestMonthlyForecastRow(countyId, horizonValue) {
            if (!Number.isFinite(countyId) || !Number.isFinite(horizonValue)) return null;
            const rows = getSortedFuturePredictions(countyId)
                .filter(row => row._horizon_months === horizonValue);
            if (!rows.length) return null;

            rows.sort((a, b) => {
                const aOrigin = parseDateOrNull(a.origin_month_start) || parseDateOrNull(a.base_month_start) || parseDateOrNull(a.target_month_start);
                const bOrigin = parseDateOrNull(b.origin_month_start) || parseDateOrNull(b.base_month_start) || parseDateOrNull(b.target_month_start);
                if (aOrigin && bOrigin && aOrigin.getTime() !== bOrigin.getTime()) return bOrigin - aOrigin;
                if (aOrigin && !bOrigin) return -1;
                if (!aOrigin && bOrigin) return 1;

                const aTarget = parseDateOrNull(a.target_month_start);
                const bTarget = parseDateOrNull(b.target_month_start);
                if (aTarget && bTarget) return bTarget - aTarget;
                if (aTarget && !bTarget) return -1;
                if (!aTarget && bTarget) return 1;
                return 0;
            });

            return rows[0];
        }

        function getCountyNameById(id) {
            if (!id) return 'Unknown County';
            const normalized = Number(id);
            const found = counties.find(c => Number(c.county_id) === normalized);
            return found ? found.name : `County ${id}`;
        }

        function getPredictionTargetDate(row) {
            return parseDateOrNull(row.target_season_start)
                || parseDateOrNull(row.target_month_start)
                || parseDateOrNull(row.origin_season_start)
                || parseDateOrNull(row.base_month_start);
        }

        function getSortedFuturePredictions(countyId) {
            if (!countyId) return [];
            return ALL_PREDICTIONS
                .filter(r => isFutureRow(r) && r._county_id === countyId)
                .sort((a, b) => {
                    const dateA = getPredictionTargetDate(a);
                    const dateB = getPredictionTargetDate(b);
                    if (dateA && dateB) {
                        return dateA - dateB;
                    }
                    if (dateA) return -1;
                    if (dateB) return 1;
                    return (Number(a.predict_horizon_months) || 0) - (Number(b.predict_horizon_months) || 0);
                });
        }

        function getFilteredPredictionsForView() {
            const countyId = parseInt(document.getElementById('countySelect').value);
            let horizonValue = null;
            if (!countyId || !currentViewType) {
                lastPredictionFallbackMessage = '';
                return [];
            }

            if (currentViewType !== 'seasonal') {
                const horizonElement = document.getElementById('monthlyHorizon');
                horizonValue = parseInt(horizonElement?.value);
                if (!Number.isFinite(horizonValue)) return [];
            }

            const baseRows = getSortedFuturePredictions(countyId);
            if (!baseRows.length) {
                lastPredictionFallbackMessage = '';
                return [];
            }

            if (currentViewType === 'seasonal') {
                const season = document.getElementById('seasonalSeason')?.value;
                const year = document.getElementById('seasonalYear')?.value;
                if (!season || !year) {
                    lastPredictionFallbackMessage = 'Select a target season and year.';
                    return [];
                }

                const seasonRows = baseRows.filter(row => row.target_season === season);
                if (!seasonRows.length) {
                    lastPredictionFallbackMessage = 'No predictions available for that season.';
                    return [];
                }

                const exactMatches = seasonRows.filter(row => {
                    const date = parseDateOrNull(row.target_season_start);
                    return date && date.getFullYear() === Number(year);
                });

                if (exactMatches.length) {
                    lastPredictionFallbackMessage = '';
                    return exactMatches;
                }

                const targetDate = parseDateOrNull(`${Number(year)}-${SEASON_START_MONTH[season]}-01`);
                const closest = targetDate ? findClosestByDate(seasonRows, formatDateString(targetDate)) : null;
                if (closest) {
                    const closestDate = getPredictionTargetDate(closest);
                    const closestLabel = closestDate
                        ? `${season} ${closestDate.getFullYear()}`
                        : `${season}`;
                    lastPredictionFallbackMessage = `Exact ${season} ${year} unavailable; showing closest (${closestLabel}).`;
                    return [closest];
                }

                lastPredictionFallbackMessage = `Exact ${season} ${year} unavailable.`;
                return [];
            }

            return getMonthlyPredictionRows(countyId, horizonValue);
        }

        function getMonthlyPredictionRows(countyId, horizonValue) {
            if (!Number.isFinite(horizonValue)) return [];
            const selected = getLatestMonthlyForecastRow(countyId, horizonValue);
            if (!selected) {
                lastPredictionFallbackMessage = 'No monthly predictions exist for that horizon.';
                return [];
            }
            lastPredictionFallbackMessage = '';
            return [selected];
        }

        // Render predictions table filtered by selected county, view type, and horizon
        function renderPredictionsTable() {
            const tbody = document.getElementById('predictionsTableBody');
            const countyId = parseInt(document.getElementById('countySelect').value);
            const countyRows = ALL_PREDICTIONS.filter(r => r._county_id === countyId);
            const horizonValue = currentViewType === 'seasonal'
                ? document.getElementById('seasonalYear')?.value
                : parseInt(document.getElementById('monthlyHorizon')?.value);

            if (!countyId) {
                lastPredictionFallbackMessage = '';
                updateTargetPredictionNote();
                tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:#999;">Select a county to view predictions</td></tr>';
                return;
            }

            if (!currentViewType || (currentViewType !== 'seasonal' && currentViewType !== 'monthly')) {
                lastPredictionFallbackMessage = '';
                updateTargetPredictionNote();
                tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:#999;">Select Seasonal or Monthly Forecast to view predictions</td></tr>';
                return;
            }

            const filteredRows = getFilteredPredictionsForView();
            updateTargetPredictionNote();

            if (!filteredRows.length) {
                tbody.innerHTML = '<tr><td colspan="8" style="text-align:center;color:#999;">No future predictions available for this county and selection</td></tr>';
                return;
            }

            tbody.innerHTML = '';
            filteredRows.forEach(row => {
                const tempPredValue = pickField(row, 'y_pred_tmax', 'y_pred_tmean', 'y_pred_temp');
                const tempAvgValue = getAverageValueForRow(row, 'temp');
                const et0AvgValue = getAverageValueForRow(row, 'et0');
                const precipAvgValue = getAverageValueForRow(row, 'precip');
                const tempDelta = formatPredictionDelta(tempPredValue, tempAvgValue, 1, '°C');
                const et0Delta = formatPredictionDelta(row.y_pred_et0_fao_evapotranspiration, et0AvgValue, 2, 'mm');
                const precipDelta = formatPredictionDelta(row.y_pred_precip, precipAvgValue, 2, 'mm');

                const tempBadge = `<span class="pred-badge ${tempDelta.className}">${tempDelta.text}</span>`;
                const et0Badge = `<span class="pred-badge ${et0Delta.className}">${et0Delta.text}</span>`;
                const precipBadge = `<span class="pred-badge ${precipDelta.className}">${precipDelta.text}</span>`;

                const tr = document.createElement('tr');
                tr.innerHTML = `
                    <td>${getCountyNameById(row.county_id)}</td>
                    <td>${getTargetLabelForRow(row)}</td>
                    <td>${formatTemperature(tempPredValue)}</td>
                    <td>${tempBadge}</td>
                    <td>${row.y_pred_et0_fao_evapotranspiration != null ? row.y_pred_et0_fao_evapotranspiration.toFixed(2) : '—'}</td>
                    <td>${et0Badge}</td>
                    <td>${row.y_pred_precip != null ? row.y_pred_precip.toFixed(2) : '—'}</td>
                    <td>${precipBadge}</td>
                `;
                tbody.appendChild(tr);
            });
        }



        const WEATHER_LIBS = {
            chart: 'https://cdn.jsdelivr.net/npm/chart.js',
            papa: 'https://cdn.jsdelivr.net/npm/papaparse@5.4.1/papaparse.min.js',
            leafletCss: 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css',
            leafletJs: 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js',
            leafletHeat: 'https://unpkg.com/leaflet.heat@0.2.0/dist/leaflet-heat.js'
        };

        function loadScriptOnce(src) {
            return new Promise((resolve, reject) => {
                const existing = document.querySelector(`script[src="${src}"]`);
                if (existing) {
                    if (existing.dataset.loaded === 'true') {
                        resolve();
                        return;
                    }
                    existing.addEventListener('load', () => resolve(), { once: true });
                    existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
                    return;
                }
                const script = document.createElement('script');
                script.src = src;
                script.async = true;
                script.dataset.weatherLib = 'true';
                script.addEventListener('load', () => {
                    script.dataset.loaded = 'true';
                    resolve();
                }, { once: true });
                script.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
                document.head.appendChild(script);
            });
        }

        function loadStylesheetOnce(href) {
            return new Promise((resolve, reject) => {
                const existing = document.querySelector(`link[href="${href}"]`);
                if (existing) {
                    resolve();
                    return;
                }
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = href;
                link.addEventListener('load', () => resolve(), { once: true });
                link.addEventListener('error', () => reject(new Error(`Failed to load ${href}`)), { once: true });
                document.head.appendChild(link);
            });
        }

        async function ensureWeatherLibraries() {
            const loaders = [];
            if (!window.Papa) loaders.push(loadScriptOnce(WEATHER_LIBS.papa));
            if (!window.Chart) loaders.push(loadScriptOnce(WEATHER_LIBS.chart));

            if (!document.querySelector(`link[href="${WEATHER_LIBS.leafletCss}"]`)) {
                loaders.push(loadStylesheetOnce(WEATHER_LIBS.leafletCss));
            }

            if (!window.L || !window.L.map) {
                loaders.push(loadScriptOnce(WEATHER_LIBS.leafletJs));
            }

            await Promise.all(loaders);

            if (!window.L || !window.L.heatLayer) {
                await loadScriptOnce(WEATHER_LIBS.leafletHeat);
            }
        }

        function waitForWeatherDependencies() {
            const deps = [
                { name: 'Papa', check: () => window.Papa },
                { name: 'Chart', check: () => window.Chart },
                { name: 'Leaflet', check: () => window.L && L.map },
                { name: 'LeafletHeat', check: () => window.L && L.heatLayer }
            ];

            return new Promise((resolve, reject) => {
                let attempts = 0;
                const timer = setInterval(() => {
                    const ready = deps.every(dep => dep.check());
                    if (ready) {
                        clearInterval(timer);
                        resolve();
                        return;
                    }
                    attempts += 1;
                    if (attempts >= 50) {
                        clearInterval(timer);
                        const missing = deps.filter(dep => !dep.check()).map(dep => dep.name).join(', ');
                        reject(new Error(`Missing weather dependencies: ${missing}`));
                    }
                }, 100);
            });
        }

        function initializeWeatherDashboard() {
            const errorContainer = document.getElementById('errorContainer');
            if (errorContainer) {
                errorContainer.innerHTML = '<div class="error" style="background:#f6f7f9;color:#5f6b7a;border-color:#dfe3e8;">Select a county and forecast view to load data.</div>';
            }
            loadCountyData();
            initializeMap();
            setupEventListeners();
            setPredictionsPlaceholder();
            populateHistoricalRangeYears();
            syncHistoricalRangeUI();
            updateAverageColumnHeaders();
            updateTargetPredictionLabel();
            updateMonthlyTargetMonth();
        }

        function handleWeatherLoad() {
            if (!document.getElementById('map')) return;
            if (document.body.dataset.weatherInitialized) return;
            reportWeatherDebug('Weather init: starting');
            ensureWeatherLibraries()
                .then(waitForWeatherDependencies)
                .then(() => {
                    document.body.dataset.weatherInitialized = 'true';
                    initializeWeatherDashboard();
                })
                .catch(error => {
                    if ((error?.message || '').includes('Map container is already initialized')) {
                        return;
                    }
                    console.error(error);
                    reportWeatherDebug(`Weather init error: ${error.message}`);
                    setPredictionsPlaceholder('Select a forecast view and county to begin loading data.');
                });
        }

        // Initialize on Turbo navigation as well as full page load.
        document.addEventListener('turbo:load', handleWeatherLoad);
        document.addEventListener('turbolinks:load', handleWeatherLoad);
        document.addEventListener('DOMContentLoaded', handleWeatherLoad);

        function loadCountyData() {
            const countySelect = document.getElementById('countySelect');
            counties.forEach(county => {
                const option = document.createElement('option');
                option.value = county.county_id;
                option.textContent = county.name;
                countySelect.appendChild(option);
            });
            countySelect.value = '';
        }

        function initializeMap() {
            map = L.map('map').setView([53.9333, -116.5765], 6);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '© OpenStreetMap contributors'
            }).addTo(map);

            setTimeout(() => addCountyMarkers(), 500);
        }

        function addCountyMarkers() {
            counties.forEach(county => {
                const marker = L.circleMarker([county.latitude, county.longitude], {
                    radius: 6,
                    fillColor: '#3498db',
                    color: '#2c3e50',
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 0.7
                }).addTo(map);

                marker.bindTooltip(`${county.name}<br>Lat: ${county.latitude.toFixed(4)}<br>Lon: ${county.longitude.toFixed(4)}`);
                
                marker.on('click', () => {
                    document.getElementById('countySelect').value = county.county_id;
                    document.getElementById('latInput').value = county.latitude.toFixed(4);
                    document.getElementById('lonInput').value = county.longitude.toFixed(4);
                    document.getElementById('locationName').value = county.name;
                    renderPredictionsTable();
                });

                countyMarkers.push(marker);
            });
        }

        function setupEventListeners() {
            document.querySelectorAll('.tab').forEach(tab => {
                tab.addEventListener('click', (e) => {
                    switchTab(e.target.dataset.tab);
                    if (e.target.dataset.tab === 'longTerm') updateLongTermCharts();
                });
            });

            // Step 1: County selection enables Step 2
            document.getElementById('countySelect').addEventListener('change', function() {
                const selectedCounty = getSelectedCounty();
                if (selectedCounty) {
                    // Enable Step 2
                    document.getElementById('step2').classList.remove('disabled');
                    
                    // Update location data
                    document.getElementById('latInput').value = selectedCounty.latitude.toFixed(4);
                    document.getElementById('lonInput').value = selectedCounty.longitude.toFixed(4);
                    document.getElementById('locationName').value = selectedCounty.name;
                    updateMapLocation(selectedCounty.latitude, selectedCounty.longitude);
                    renderPredictionsTable();
                    updateLongTermCharts();
                    
                    const activeTab = document.querySelector('.tab.active');
                    if (activeTab && activeTab.dataset.tab === 'longTerm') updateLongTermCharts();
                    if (currentViewType === 'historical') {
                        loadHistoricalSlice();
                    }
                } else {
                    // Disable Steps 2 and 3 if no county selected
                    document.getElementById('step2').classList.add('disabled');
                    document.getElementById('step3').classList.add('disabled');
                }
            });

            document.getElementById('historicalRange').addEventListener('change', function() {
                syncHistoricalRangeUI();
                if (currentViewType === 'historical') loadHistoricalSlice();
            });

            document.getElementById('historicalSeason').addEventListener('change', function() {
                if (currentViewType === 'historical') loadHistoricalSlice();
            });

            document.getElementById('historicalYear').addEventListener('change', function() {
                if (currentViewType === 'historical') loadHistoricalSlice();
            });

            document.getElementById('historicalStartYear').addEventListener('change', function() {
                if (currentViewType === 'historical') loadHistoricalSlice();
            });

            document.getElementById('historicalEndYear').addEventListener('change', function() {
                if (currentViewType === 'historical') loadHistoricalSlice();
            });

            // Step 2: Data view selection enables Step 3 and shows appropriate controls
            document.querySelectorAll('.forecast-btn').forEach(button => {
                button.addEventListener('click', async () => {
                    // Remove active class from all buttons
                    document.querySelectorAll('.forecast-btn').forEach(btn => btn.classList.remove('active'));
                    // Add active class to clicked button
                    button.classList.add('active');
                    
                    // Enable Step 3
                    document.getElementById('step3').classList.remove('disabled');
                    
                    // Show appropriate controls based on view type
                    const viewType = button.getAttribute('data-view-type');
                    currentViewType = viewType; // Track current view type

                    const targetColumnHeader = document.getElementById('targetColumnHeader');
                    if (targetColumnHeader) {
                        targetColumnHeader.textContent = viewType === 'monthly' ? 'Target Month' : 'Target Season';
                    }

                    const seasonalGroup = document.getElementById('seasonalGroup');
                    const monthlyGroup = document.getElementById('monthlyGroup');
                    const historicalGroup = document.getElementById('historicalGroup');
                    const currentGroup = document.getElementById('currentGroup');
                    const averageWindowGroup = document.getElementById('averageWindowGroup');
                    
                    // Hide all groups first
                    seasonalGroup.classList.remove('visible');
                    monthlyGroup.classList.remove('visible');
                    historicalGroup.classList.remove('visible');
                    currentGroup.classList.remove('visible');
                    if (averageWindowGroup) averageWindowGroup.style.display = 'none';
                    
                    // Load appropriate data and show controls
                    if (viewType === 'seasonal') {
                        seasonalGroup.classList.add('visible');
                        if (averageWindowGroup) averageWindowGroup.style.display = 'block';
                        await loadHistoricalAverageDataset('seasonal').catch(error => {
                            reportWeatherDebug(error.message || String(error));
                        });
                        await loadDataForViewType('seasonal');
                        renderPredictionsTable();
                        updateLongTermCharts();
                        switchTab('longTerm');
                        if (document.getElementById('countySelect').value) {
                            fetchWeatherData();
                        }
                    } else if (viewType === 'monthly') {
                        monthlyGroup.classList.add('visible');
                        if (averageWindowGroup) averageWindowGroup.style.display = 'block';
                        await loadHistoricalAverageDataset('monthly').catch(error => {
                            reportWeatherDebug(error.message || String(error));
                        });
                        const hasCounty = Boolean(document.getElementById('countySelect').value);
                        if (hasCounty) {
                            fetchWeatherData()
                                .then(() => updateMonthlyTargetMonth())
                                .catch(() => updateMonthlyTargetMonth());
                        }
                        await loadDataForViewType('monthly');
                        renderPredictionsTable();
                        updateLongTermCharts();
                        updateMonthlyTargetMonth();
                        switchTab('longTerm');
                    } else if (viewType === 'historical') {
                        historicalGroup.classList.add('visible');
                        syncHistoricalRangeUI();
                        await loadDataForViewType('historical');
                        const targetGroup = document.getElementById('targetRangeGroup');
                        if (targetGroup) targetGroup.style.display = 'none';
                        switchTab('historical');
                    } else if (viewType === 'current') {
                        currentGroup.classList.add('visible');
                        switchTab('table');
                        if (document.getElementById('countySelect').value) {
                            await fetchWeatherData();
                        }
                    }
                    updateTargetPredictionLabel();
                });
            });

            // Seasonal horizon change event
            document.getElementById('seasonalSeason').addEventListener('change', function() {
                renderPredictionsTable();
                updateLongTermCharts();
                updateTargetPredictionLabel();
            });

            document.getElementById('seasonalYear').addEventListener('change', function() {
                renderPredictionsTable();
                updateLongTermCharts();
                const countyId = parseInt(document.getElementById('countySelect').value);
            if (countyId && currentMarker) {
                const lat = parseFloat(document.getElementById('latInput').value);
                const lon = parseFloat(document.getElementById('lonInput').value);
                updateMapMarker(lat, lon, mapCurrentWeather || currentWeatherData[0], currentWeatherData);
            }
            updateTargetPredictionLabel();
            });

            // Monthly horizon change event
            const monthlyHorizonSelect = document.getElementById('monthlyHorizon');
            const onMonthlyHorizonChange = function() {
                renderPredictionsTable();
                updateLongTermCharts();
                updateMonthlyTargetMonth();
                const countyId = parseInt(document.getElementById('countySelect').value);
            if (countyId && currentMarker) {
                const lat = parseFloat(document.getElementById('latInput').value);
                const lon = parseFloat(document.getElementById('lonInput').value);
                updateMapMarker(lat, lon, mapCurrentWeather || currentWeatherData[0], currentWeatherData);
            }
            updateTargetPredictionLabel();
        };
            monthlyHorizonSelect.addEventListener('change', onMonthlyHorizonChange);
            monthlyHorizonSelect.addEventListener('input', onMonthlyHorizonChange);

            const averageWindowSelect = document.getElementById('historicalAverageWindow');
            if (averageWindowSelect) {
                averageWindowSelect.addEventListener('change', async function() {
                    const nextValue = Number(this.value);
                    if (!Number.isFinite(nextValue)) return;
                    selectedAverageWindowYears = nextValue;
                    updateAverageColumnHeaders();
                    if (currentViewType === 'seasonal' || currentViewType === 'monthly') {
                        await loadHistoricalAverageDataset(currentViewType).catch(error => {
                            reportWeatherDebug(error.message || String(error));
                        });
                        renderPredictionsTable();
                        updateLongTermCharts();
                    }
                });
            }

            document.getElementById('historicalSeason').addEventListener('change', function() {
                if (currentViewType === 'historical') {
                    loadHistoricalSlice();
                }
            });

            document.getElementById('historicalYear').addEventListener('change', function() {
                if (currentViewType === 'historical') {
                    loadHistoricalSlice();
                }
            });

            document.getElementById('exportPredictionsBtn').addEventListener('click', function() {
                exportPredictionsData();
            });

            document.getElementById('exportHistoricalBtn').addEventListener('click', function() {
                exportHistoricalData();
            });

            document.getElementById('exportWeatherBtn').addEventListener('click', function() {
                exportWeatherData();
            });

            document.getElementById('getWeatherBtn').addEventListener('click', fetchWeatherData);

            // Remove the map layer switcher event listener since we removed the controls
            // document.addEventListener('change', function(e) {
            //     if (e.target.name === 'mapLayer') {
            //         switchMapLayer(e.target.value);
            //     }
            // });
        }

        function switchTab(tabName) {
            document.querySelectorAll('.tab').forEach(tab => tab.classList.remove('active'));
            document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
            
            document.querySelector(`[data-tab="${tabName}"]`).classList.add('active');
            document.getElementById(`${tabName}Tab`).classList.add('active');
        }

        function getSelectedCounty() {
            const countyId = parseInt(document.getElementById('countySelect').value);
            return counties.find(county => county.county_id === countyId);
        }

        function updateMapLocation(lat, lon) {
            map.setView([lat, lon], 10);
            
            if (currentMarker) map.removeLayer(currentMarker);
            
            currentMarker = L.marker([lat, lon], {
                icon: L.divIcon({
                    html: '📍',
                    iconSize: [20, 20],
                    className: 'custom-marker'
                })
            }).addTo(map);
        }

        async function fetchRealWeatherData(lat, lon, days) {
            const params = new URLSearchParams({
                latitude: lat.toFixed(4),
                longitude: lon.toFixed(4),
                current_weather: 'true',
                daily: 'temperature_2m_max,temperature_2m_min,temperature_2m_mean,precipitation_sum,windspeed_10m_max,weather_code,et0_fao_evapotranspiration',
                hourly: 'temperature_2m,precipitation,windspeed_10m,winddirection_10m,weathercode,et0_fao_evapotranspiration',
                timezone: 'auto',
                forecast_days: Math.min(Number(days) || 7, 16)
            });

            const response = await fetch(`https://api.open-meteo.com/v1/forecast?${params}`);
            if (!response.ok) throw new Error(`Weather API Error: ${response.status}`);
            
            const data = await response.json();
            return processOpenMeteoData(data, days);
        }

        async function fetchCurrentPopupWeather(lat, lon) {
            const params = new URLSearchParams({
                latitude: lat.toFixed(4),
                longitude: lon.toFixed(4),
                current: 'temperature_2m,precipitation,weather_code,wind_speed_10m,wind_direction_10m',
                timezone: 'auto'
            });

            const response = await fetch(`https://api.open-meteo.com/v1/forecast?${params}`);
            if (!response.ok) throw new Error(`Current weather API Error: ${response.status}`);

            const data = await response.json();
            const current = data.current || {};
            const weatherCode = current.weather_code;
            const parsedDate = current.time ? new Date(current.time) : null;
            const windDir = Number.isFinite(Number(current.wind_direction_10m))
                ? Number(current.wind_direction_10m)
                : null;
            const conditionText = getWeatherCondition(weatherCode);

            return {
                date: parsedDate,
                temperature: Number.isFinite(Number(current.temperature_2m))
                    ? Math.round(Number(current.temperature_2m))
                    : null,
                precipitation: Number.isFinite(Number(current.precipitation))
                    ? Math.round(Number(current.precipitation) * 100) / 100
                    : null,
                windSpeed: Number.isFinite(Number(current.wind_speed_10m))
                    ? Math.round(Number(current.wind_speed_10m))
                    : null,
                windDirection: windDir,
                windDirectionLabel: formatWindDirection(windDir),
                conditions: conditionText,
                conditionIcon: getWeatherIcon(conditionText),
                timeLabel: parsedDate ? formatTimeLabel(parsedDate) : ''
            };
        }

        function processOpenMeteoData(apiData, requestedDays) {
            const hourlyForecasts = [];
            const dailyForecasts = [];
            const hourly = apiData.hourly || {};
            const daily = apiData.daily || {};

            if (hourly.time && Array.isArray(hourly.time)) {
                const maxHours = Math.min(hourly.time.length, (Number(requestedDays) || 7) * 24);
                for (let i = 0; i < maxHours; i++) {
                    const timeStr = hourly.time[i];
                    const dateObj = new Date(timeStr);
                    const hourlyWeatherCodes = hourly.weather_code || hourly.weathercode || [];
                    const conditionText = getWeatherCondition(hourlyWeatherCodes[i]);

                    const rawTemp = hourly.temperature_2m && hourly.temperature_2m[i] !== undefined ? Number(hourly.temperature_2m[i]) : null;
                    const tempValue = Number.isFinite(rawTemp) ? Math.round(rawTemp) : null;

                    const rawPrecip = hourly.precipitation && hourly.precipitation[i] !== undefined ? Number(hourly.precipitation[i]) : null;
                    const precipValue = Number.isFinite(rawPrecip) ? Math.round(rawPrecip * 100) / 100 : 0;

                    const rawEt0 = hourly.et0_fao_evapotranspiration && hourly.et0_fao_evapotranspiration[i] !== undefined
                        ? Number(hourly.et0_fao_evapotranspiration[i]) : null;
                    const et0Value = Number.isFinite(rawEt0) ? Math.round(rawEt0 * 1000) / 1000 : null;

                    const hourlyWindSpeed = hourly.wind_speed_10m || hourly.windspeed_10m || [];
                    const rawWindSpeed = hourlyWindSpeed[i] !== undefined ? Number(hourlyWindSpeed[i]) : null;
                    const windSpeedValue = Number.isFinite(rawWindSpeed) ? Math.round(rawWindSpeed) : null;

                    const hourlyWindDirection = hourly.wind_direction_10m || hourly.winddirection_10m || [];
                    const windDir = hourlyWindDirection[i] !== undefined
                        ? Number(hourlyWindDirection[i])
                        : null;

                    hourlyForecasts.push({
                        date: dateObj,
                        temperature: tempValue,
                        precipitation: precipValue,
                        et0: et0Value,
                        windSpeed: windSpeedValue,
                        windDirection: windDir,
                        windDirectionLabel: formatWindDirection(windDir),
                        conditions: conditionText,
                        conditionIcon: getWeatherIcon(conditionText),
                        timeLabel: formatTimeLabel(dateObj)
                    });
                }
            } else if (daily.time) {
                // Fallback to daily data if hourly is unavailable
                const dailyData = daily;
                const dailyWeatherCodes = dailyData.weather_code || dailyData.weathercode || [];
                const numDays = Math.min(requestedDays, dailyData.time.length);
                
                for (let i = 0; i < numDays; i++) {
                    const conditionText = getWeatherCondition(dailyWeatherCodes[i]);
                    hourlyForecasts.push({
                        date: new Date(dailyData.time[i]),
                        temperature: Math.round(dailyData.temperature_2m_max[i]),
                        precipitation: Math.round((dailyData.precipitation_sum[i] || 0) * 100) / 100,
                        et0: dailyData.et0_fao_evapotranspiration ? Math.round((dailyData.et0_fao_evapotranspiration[i] || 0) * 1000) / 1000 : null,
                        windSpeed: Math.round(dailyData.wind_speed_10m_max ? dailyData.wind_speed_10m_max[i] || 0 : 0),
                        conditions: conditionText,
                        conditionIcon: getWeatherIcon(conditionText),
                        timeLabel: ''
                    });
                }
            }
            if (daily.time) {
                const dailyData = daily;
                const dailyWeatherCodes = dailyData.weather_code || dailyData.weathercode || [];
                const numDays = Math.min(requestedDays, dailyData.time.length);
                for (let i = 0; i < numDays; i++) {
                    const conditionText = getWeatherCondition(dailyWeatherCodes[i]);
                    dailyForecasts.push({
                        date: new Date(dailyData.time[i]),
                        temperature: Math.round(dailyData.temperature_2m_max[i]),
                        precipitation: Math.round((dailyData.precipitation_sum[i] || 0) * 100) / 100,
                        et0: dailyData.et0_fao_evapotranspiration ? Math.round((dailyData.et0_fao_evapotranspiration[i] || 0) * 1000) / 1000 : null,
                        windSpeed: dailyData.wind_speed_10m_max ? Math.round(dailyData.wind_speed_10m_max[i] || 0) : null,
                        conditions: conditionText,
                        conditionIcon: getWeatherIcon(conditionText),
                        timeLabel: ''
                    });
                }
            }

            if (!hourlyForecasts.length) {
                throw new Error('No weather data returned for the selected location.');
            }
            return { hourly: hourlyForecasts, daily: dailyForecasts };
        }

        const WEATHER_CONDITION_ICONS = {
            'Clear Sky': '☀️',
            'Mainly Clear': '🌤️',
            'Partly Cloudy': '⛅',
            'Overcast': '☁️',
            'Fog': '🌫️',
            'Light Drizzle': '🌦️',
            'Slight Rain': '🌦️',
            'Moderate Rain': '🌧️',
            'Heavy Rain': '⛈️',
            'Slight Snow': '🌨️',
            'Moderate Snow': '❄️',
            'Heavy Snow': '❄️',
            'Thunderstorm': '⛈️',
            'Unknown': '❔'
        };

        function getWeatherCondition(weatherCode) {
            const codes = {
                0: 'Clear Sky', 1: 'Mainly Clear', 2: 'Partly Cloudy', 3: 'Overcast',
                45: 'Fog', 51: 'Light Drizzle', 61: 'Slight Rain', 63: 'Moderate Rain',
                65: 'Heavy Rain', 71: 'Slight Snow', 73: 'Moderate Snow', 75: 'Heavy Snow',
                95: 'Thunderstorm'
            };
            return codes[weatherCode] || 'Unknown';
        }

        function getWeatherIcon(condition) {
            if (!condition) return '❔';
            return WEATHER_CONDITION_ICONS[condition] || '❔';
        }

    
        

        // Map layer switching disabled - heat maps removed
        // function switchMapLayer(layerType) {
        //     temperatureHeatLayers.forEach(layer => { if (map.hasLayer(layer)) map.removeLayer(layer); });
        //     precipitationHeatLayers.forEach(layer => { if (map.hasLayer(layer)) map.removeLayer(layer); });
        //     const showMarkers = layerType === 'standard';
        //     const showAnimationControls = layerType === 'temperature' || layerType === 'precipitation';
        //     countyMarkers.forEach(marker => {
        //         if (showMarkers) {
        //             if (!map.hasLayer(marker)) map.addLayer(marker);
        //         } else {
        //             if (map.hasLayer(marker)) map.removeLayer(marker);
        //         }
        //     });
        //     document.getElementById('animationControls').style.display = showAnimationControls ? 'block' : 'none';
        //     if (layerType === 'temperature' || layerType === 'precipitation') {
        //         updateHeatMapFrame();
        //     }
        // }
        async function fetchWeatherData() {
            const lat = parseFloat(document.getElementById('latInput').value);
            const lon = parseFloat(document.getElementById('lonInput').value);
            const days = parseInt(document.getElementById('forecastDays').value);
            const locationInput = document.getElementById('locationName');
            const locationName = locationInput ? locationInput.value : (getSelectedCounty()?.name || 'Selected Location');

            if (!lat || !lon) {
                showError('Please enter valid coordinates or select a county');
                return;
            }

            showLoading();
            clearError();

            try {
                const weatherData = await fetchRealWeatherData(lat, lon, days);
                currentWeatherData = weatherData.daily;
                try {
                    mapCurrentWeather = await fetchCurrentPopupWeather(lat, lon);
                } catch (popupError) {
                    console.warn('Current popup weather fetch failed, using hourly fallback:', popupError);
                    mapCurrentWeather = weatherData.hourly?.[0] || null;
                }
                
                displayCountyInfo(lat, lon, locationName);
                updateCharts(weatherData.daily);
                updateTable(weatherData.daily);
                updateMapMarker(lat, lon, mapCurrentWeather || weatherData.hourly[0], weatherData.hourly);
                updateMonthlyTargetMonth();
            } catch (error) {
                console.error(error);
                reportWeatherDebug(`Weather fetch error: ${error?.message || error}`);
                showError('Weather data is temporarily unavailable.');
            } finally {
                clearLoading();
            }
        }

        function displayCountyInfo() {
            const countyInfo = document.getElementById('countyInfo');
            if (countyInfo) countyInfo.innerHTML = '';
        }

        function updateCharts(dailyWeather) {
            const labels = dailyWeather.map(d => {
                if (!(d.date instanceof Date)) return '';
                return d.date.toLocaleDateString('en-CA', { month: 'short', day: 'numeric' });
            });
            const temperatures = dailyWeather.map(d => d.temperature);
            const precipitation = dailyWeather.map(d => d.precipitation);

            const tempCtx = document.getElementById('temperatureChart').getContext('2d');
            if (temperatureChart) temperatureChart.destroy();
            temperatureChart = new Chart(tempCtx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Max Temperature (°C)',
                        data: temperatures,
                        borderColor: '#e74c3c',
                        backgroundColor: 'rgba(231, 76, 60, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: false } }
                }
            });

            const precCtx = document.getElementById('precipitationChart').getContext('2d');
            if (precipitationChart) precipitationChart.destroy();
            precipitationChart = new Chart(precCtx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Precipitation (mm)',
                        data: precipitation,
                        borderColor: '#3498db',
                        backgroundColor: 'rgba(52, 152, 219, 0.15)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: true } }
                }
            });
        }

        function updateTable(weatherData) {
            const tbody = document.getElementById('weatherTableBody');
            tbody.innerHTML = '';
            weatherData.forEach(data => {
                const row = document.createElement('tr');
                // Convert date string to Date object
                const dateObj = new Date(data.date);

                // Format as "Month Day, Year (time)"
                const formattedDate = dateObj.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
                const timeLabel = formatTimeLabel(dateObj);
                const windDir = data.windDirectionLabel ? ` [${data.windDirectionLabel}]` : '';
                const et0 = data.et0 != null ? Number(data.et0).toFixed(3) : '—';
                const precip = data.precipitation != null ? Number(data.precipitation).toFixed(2) : '—';
                const tempValue = data.temperature != null ? data.temperature : '—';

                row.innerHTML = `
                    <td>${formattedDate}${timeLabel ? ` (${timeLabel})` : ''}</td>
                    <td style="color: ${tempValue < 0 ? '#3498db' : '#e74c3c'};">${tempValue}°C</td>
                    <td>${precip}mm</td>
                    <td>${et0}</td>
                    <td>${data.windSpeed || 0} km/h${windDir}</td>
                    <td>
                        <div class="weather-condition">
                            <span class="weather-condition-icon">${data.conditionIcon || getWeatherIcon(data.conditions)}</span>
                            <span>${data.conditions || '—'}</span>
                        </div>
                    </td>
                `;
                tbody.appendChild(row);
            });
        }

        function updateMapMarker(lat, lon, currentWeather, hourlyWeather = []) {
            updateMapLocation(lat, lon);
            
            if (currentMarker && currentWeather) {
                const predCardHtml = '';
                
                const conditionIcon = currentWeather.conditionIcon || getWeatherIcon(currentWeather.conditions);
                const timeLabel = currentWeather.timeLabel
                    ? ` (Last updated at ${currentWeather.timeLabel})`
                    : '';
                const windDirLabel = currentWeather.windDirectionLabel ? ` [${currentWeather.windDirectionLabel}]` : '';
                const locationInput = document.getElementById('locationName');
                const locationLabel = locationInput ? locationInput.value : (getSelectedCounty()?.name || 'Selected Location');
                const popupContent = `
                    <div class="map-popup-card" style="min-width: 250px; max-width: 320px;">
                        <h4 style="color: #2c3e50;">${locationLabel}</h4>
                        <div class="map-popup-card-body">
                            <div style="font-weight: 600; margin-bottom: 5px;">Current Weather${timeLabel}</div>
                            <div class="map-popup-temperature">
                                <span style="color: ${currentWeather.temperature < 0 ? '#3498db' : '#e74c3c'};">
                                    ${currentWeather.temperature}°C
                                </span>
                            </div>
                            <div class="map-popup-condition">
                                <span class="weather-condition-icon map-popup-condition-icon">${conditionIcon}</span>
                                <span>${currentWeather.conditions || '—'}</span>
                            </div>
                            <div class="map-popup-metrics">
                                💧 ${currentWeather.precipitation}mm | 💨 ${currentWeather.windSpeed} km/h${windDirLabel}
                            </div>
                        </div>
                        ${predCardHtml}
                    </div>
                `;
                currentMarker.bindPopup(popupContent, { maxWidth: 320 }).openPopup();
            }
        }

        function updateLongTermCharts() {
            const countyId = parseInt(document.getElementById('countySelect').value);
            if (!countyId) return;

            if (!currentViewType || (currentViewType !== 'seasonal' && currentViewType !== 'monthly')) {
                document.getElementById('longTermError').innerHTML = '<div class="error">Please select Seasonal or Monthly Forecast view</div>';
                return;
            }

            const allRows = getSortedFuturePredictions(countyId);
            if (!allRows.length) {
                document.getElementById('longTermError').innerHTML = '<div class="error">No future predictions available for this county</div>';
                return;
            }

            let chartRows = [];
            let horizonLabel = '';
            if (currentViewType === 'seasonal') {
                const season = document.getElementById('seasonalSeason')?.value;
                const year = Number(document.getElementById('seasonalYear')?.value);
                if (!season || !Number.isFinite(year)) {
                    document.getElementById('longTermError').innerHTML = '<div class="error">Select a target season and year</div>';
                    return;
                }

                const targetDate = parseDateOrNull(`${year}-${SEASON_START_MONTH[season]}-01`);
                const seasonRows = allRows
                    .sort((a, b) => {
                        const da = getPredictionTargetDate(a);
                        const db = getPredictionTargetDate(b);
                        if (da && db) return da - db;
                        if (da) return -1;
                        if (db) return 1;
                        return 0;
                    });

                chartRows = seasonRows.filter(row => {
                    const d = getPredictionTargetDate(row);
                    return d && targetDate && d <= targetDate;
                });
                if (!chartRows.length) {
                    chartRows = seasonRows;
                }
                horizonLabel = `${season} ${year}`;
            } else {
                const horizonValue = parseInt(document.getElementById('monthlyHorizon')?.value);
                if (!Number.isFinite(horizonValue)) {
                    document.getElementById('longTermError').innerHTML = '<div class="error">Select a valid forecast horizon</div>';
                    return;
                }
                const selectedRow = getLatestMonthlyForecastRow(countyId, horizonValue);
                const targetDate = parseDateOrNull(selectedRow?.target_month_start);
                const monthlyRows = allRows
                    .map(row => ({ row, date: parseDateOrNull(row.target_month_start) }))
                    .filter(entry => entry.date)
                    .sort((a, b) => a.date - b.date);
                chartRows = monthlyRows
                    .filter(entry => targetDate && entry.date <= targetDate)
                    .map(entry => entry.row);
                if (!chartRows.length) {
                    chartRows = monthlyRows.map(entry => entry.row);
                }
                const targetLabel = targetDate
                    ? targetDate.toLocaleString('en-US', { month: 'long', year: 'numeric' })
                    : '';
                horizonLabel = formatHorizonLabel('monthly', horizonValue, targetLabel);
            }

            if (!chartRows.length) {
                document.getElementById('longTermError').innerHTML = '<div class="error">No long-term forecast predictions for this county and horizon.</div>';
                return;
            }
            document.getElementById('longTermError').innerHTML = '';

            const labels = chartRows.map(r => {
                const label = getTargetLabelForRow(r);
                if (label && label !== '—') return label;
                if (currentViewType === 'seasonal') {
                    const seasons = Number(r.predict_horizon_seasons) || Number(r.predict_horizon_months) || 0;
                    return `Horizon ${seasons} season${seasons === 1 ? '' : 's'}`;
                }
                const months = Number(r.predict_horizon_months) || 0;
                return `Horizon ${months} month${months === 1 ? '' : 's'}`;
            });
            const tempData = chartRows.map(r => {
                const value = pickField(r, 'y_pred_tmax', 'y_pred_tmean', 'y_pred_temp');
                return value != null ? Math.round(Number(value)) : null;
            });
            const et0Data = chartRows.map(r => r.y_pred_et0_fao_evapotranspiration != null ? Number(r.y_pred_et0_fao_evapotranspiration) : null);
            const precipData = chartRows.map(r => r.y_pred_precip != null ? Number(r.y_pred_precip) : null);
            const tempAvg = chartRows.map(r => {
                const value = getAverageValueForRow(r, 'temp');
                return Number.isFinite(value) ? value : null;
            });
            const et0Avg = chartRows.map(r => {
                const value = getAverageValueForRow(r, 'et0');
                return Number.isFinite(value) ? value : null;
            });
            const precipAvg = chartRows.map(r => {
                const value = getAverageValueForRow(r, 'precip');
                return Number.isFinite(value) ? value : null;
            });
            const historicalAvgLabel = getHistoricalAvgLabel();

            console.log('Long-term charts:', chartRows.length, 'forecast rows (future only)');

            // Temperature Forecast Chart
            const tempCtx = document.getElementById('tempForecastChart').getContext('2d');
            if (tempForecastChart) tempForecastChart.destroy();
            tempForecastChart = new Chart(tempCtx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: currentViewType === 'monthly' ? 'Predicted Temperature (°C)' : 'Predicted Max Temperature (°C)',
                        data: tempData,
                        borderColor: '#e67e22',
                        backgroundColor: 'rgba(230, 126, 34, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }, {
                        label: historicalAvgLabel,
                        data: tempAvg,
                        borderColor: '#7f8c8d',
                        borderWidth: 2,
                        borderDash: [6, 4],
                        pointRadius: 0,
                        fill: false,
                        tension: 0.2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: false } },
                    plugins: {
                        title: {
                            display: true,
                            text: horizonLabel,
                            font: { size: 14, weight: 'bold' }
                        }
                    }
                }
            });

            // ET0 Forecast Chart
            const et0Ctx = document.getElementById('et0ForecastChart').getContext('2d');
            if (et0ForecastChart) et0ForecastChart.destroy();
            et0ForecastChart = new Chart(et0Ctx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Predicted ET₀ (mm)',
                        data: et0Data,
                        borderColor: '#16a085',
                        backgroundColor: 'rgba(22, 160, 133, 0.1)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.4
                    }, {
                        label: historicalAvgLabel,
                        data: et0Avg,
                        borderColor: '#7f8c8d',
                        borderWidth: 2,
                        borderDash: [6, 4],
                        pointRadius: 0,
                        fill: false,
                        tension: 0.2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: false } },
                    plugins: {
                        title: {
                            display: true,
                            text: horizonLabel,
                            font: { size: 14, weight: 'bold' }
                        }
                    }
                }
            });

            // Precipitation Forecast Chart
            const precipCtx = document.getElementById('precipForecastChart').getContext('2d');
            if (precipForecastChart) precipForecastChart.destroy();
            precipForecastChart = new Chart(precipCtx, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Predicted Precipitation (mm)',
                        data: precipData,
                        borderColor: '#3498db',
                        backgroundColor: 'rgba(52, 152, 219, 0.15)',
                        borderWidth: 3,
                        fill: true,
                        tension: 0.35
                    }, {
                        label: historicalAvgLabel,
                        data: precipAvg,
                        borderColor: '#7f8c8d',
                        borderWidth: 2,
                        borderDash: [6, 4],
                        pointRadius: 0,
                        fill: false,
                        tension: 0.2
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: { y: { beginAtZero: true } },
                    plugins: {
                        title: {
                            display: true,
                            text: horizonLabel,
                            font: { size: 14, weight: 'bold' }
                        }
                    }
                }
            });
        }

        function getHistoricalAvgLabel() {
            return `${selectedAverageWindowYears}-year historical avg`;
        }
        function showLoading() {
            const button = document.getElementById('getWeatherBtn');
            document.getElementById('weatherTableBody').innerHTML = '<tr><td colspan="6" class="loading"><div class="spinner"></div>Loading...</td></tr>';
            button.disabled = true;
            button.classList.add('loading');
            button.textContent = 'Loading Weather';
            if (temperatureChart) temperatureChart.destroy();
            if (precipitationChart) precipitationChart.destroy();
        }

        function clearLoading() {
            const button = document.getElementById('getWeatherBtn');
            button.disabled = false;
            button.classList.remove('loading');
            button.textContent = 'Get Weather';
        }

        function showError(message) {
            document.getElementById('errorContainer').innerHTML = `<div class="error">${message}</div>`;
        }

        function reportWeatherDebug(message) {
            if (!message) return;
            console.debug(`[weather] ${message}`);
        }

        function clearError() {
            document.getElementById('errorContainer').innerHTML = '';
        }

        function exportWeatherData() {
            if (currentWeatherData.length === 0) {
                showError('No weather data to export');
                return;
            }
            const csvContent = "data:text/csv;charset=utf-8," 
                + "Date,Time,Temperature(°C),Precipitation(mm),ET0(mm),WindSpeed(km/h),WindDirection,Conditions\n"
                + currentWeatherData.map(d => {
                    const dateStr = d.date instanceof Date ? d.date.toISOString().split('T')[0] : '';
                    const timeStr = d.timeLabel || '';
                    const windDir = d.windDirectionLabel || '';
                    const et0 = d.et0 != null ? d.et0 : '';
                    return `${dateStr},${timeStr},${d.temperature ?? ''},${d.precipitation ?? ''},${et0},${d.windSpeed ?? ''},${windDir},"${d.conditions ?? ''}"`;
                }).join("\n");
            const link = document.createElement("a");
            link.setAttribute("href", encodeURI(csvContent));
            link.setAttribute("download", `weather_data_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
